import { sortByDate } from "@utils/sorters";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { isAfter, isBefore, parse } from "date-fns";
import { formatDate, formatTime } from "@utils/dates";

const endpoint:string = 'opportunities/signups';

export function useGetAllOpportunitySignUps(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetOpportunitySignUp(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateOpportunitySignUp() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateOpportunitySignUp({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteOpportunitySignUp({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
